<div class="title-panel">
    Configuração de Alteração de Dados
</div>
<mat-divider></mat-divider>
<div class="info">
    Nessa etapa serão definidas as informações alterar o registros de uma tabela a cada requisição.
</div>

<mat-divider></mat-divider>
<div class="data-save-body">
    <expanse-panel title="Geral" [startOpen]="true">
        <search-input class="search-input-dados" [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpdic" [form]="formGroup"  [condition]="conditionSearch" entitydesc="Tabela de Entidades" controlname="idInstance" placeholder="Tabela" fieldname="INSTANCENAME" columnname="IDINSTANCE" class="no-padding-form-field-5px" >
        </search-input>
        <mat-form-field [formGroup]="formGroup"  appearance="outline" class="no-padding-form-field-5px full-width" >
            <mat-label>Filtro da Entidade</mat-label>
            <input  tabindex="1" type = "text" matInput formControlName="filter" placeholder="Filtro da Entidade"  [disabled]="true" #inpFilter > 
            <button tabindex="-1"   type="button" *ngIf="inpFilter.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpFilter.value=''" >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <div class="more-options-horizontal">
            <mat-form-field [formGroup]="stepDataSave"  appearance="outline" class="no-padding-form-field-5px full-width"
            matTooltip="Código de Status de Sucesso que o sistema gravará no campo Status em caso de Sucesso." matTooltipClass="toolTip-request">
                <mat-label>Status de Sucesso</mat-label>
                <input  tabindex="1" type = "text" matInput formControlName="SUCCESSSTATUS" placeholder="Código de Status de Sucesso. Ex: 1"  required #inpStatusSuccess > 
                <button    tabindex="-1"  type="button" *ngIf="inpStatusSuccess.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpStatusSuccess.value=''" >
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field [formGroup]="stepDataSave"  appearance="outline" class="no-padding-form-field-5px full-width"
            matTooltip="Código de Status de Erro que o sistema gravará no campo Status em caso de Erro." matTooltipClass="toolTip-request">
                <mat-label>Status de Erro</mat-label>
                <input  tabindex="1" type = "text" matInput formControlName="ERRORSTATUS" placeholder="Código de Status de Sucesso. Ex: 2"  required #inpStatusError > 
                <button    tabindex="-1"  type="button" *ngIf="inpStatusError.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpStatusError.value=''" >
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </expanse-panel>
    <expanse-panel title="Propriedades Avançadas" [open]="openpa">
        <div class="more-options">
            <mat-slide-toggle  matTooltip="Não será gravado a mensagem padrão no campo MESSAGE" matTooltipClass="toolTip-request" [(ngModel)]="ignoreMessage" [ngModelOptions]="{standalone: true}" (change)="onToggleChange($event,'ignoreMessage')">Não gravar mensagem Padrão
            </mat-slide-toggle>
            <mat-slide-toggle  matTooltip="Não será gravado o status padrão no campo STATUS" matTooltipClass="toolTip-request" [(ngModel)]="ignoreStatus"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange($event,'ignoreStatus')">Não gravar status Padrão
            </mat-slide-toggle>
            <mat-slide-toggle  matTooltip="Não será gravado o Payload de retorno no campo REQUESTBODY" matTooltipClass="toolTip-request" [(ngModel)]="ignoreRequest"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange($event,'ignoreRequest')">Não gravar RequestBody Padrão
            </mat-slide-toggle>
            <mat-slide-toggle  matTooltip="Não será gravado o Payload de envio no campo RESPONSEBODY" matTooltipClass="toolTip-request" [(ngModel)]="ignoreResponse"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange($event,'ignoreResponse')">Não gravar ResponseBody Padrão
            </mat-slide-toggle>
        </div>  
    </expanse-panel>
    <mat-divider></mat-divider>
    <expanse-panel title="Campos de Gravação" [open]="opensr">
        <mat-form-field class="no-padding-form-field-5px full-width">
            <mat-label>Filtrar Campos</mat-label>
            <input matInput (keyup)="applyFilter($event)"  #input>
        </mat-form-field>
          
        <mat-table  [dataSource]="columns" class="mat-elevation-z8">
            <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef> Descrição </th>
            <td mat-cell *matCellDef="let column"> {{column.COLUMNDESC}} </td>
            </ng-container>
    
            <ng-container matColumnDef="field">
            <th mat-header-cell *matHeaderCellDef> Campo </th>
            <td mat-cell *matCellDef="let column"> {{column.COLUMNNAME}} </td>
            </ng-container>
    
            <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Tipo de Dado </th>
            <td mat-cell *matCellDef="let column">  {{column.DATATYPE}} ( {{column.COLSIZE}} )</td>
            </ng-container>
        
            <!--ng-container matColumnDef="filter">
                <th mat-header-cell *matHeaderCellDef>Filtro</th>
                <td mat-cell *matCellDef="let column" >
                    <div class="cell-content">
                        <mat-form-field class="no-padding-form-field-5px grid-input">            
                            <input matInput [(ngModel)]="column.filter" (ngModelChange)="changeEventoFilter($event)">
                        </mat-form-field>
                    </div>
                </td>
            </ng-container-->
            
            <ng-container matColumnDef="df">
            <th mat-header-cell *matHeaderCellDef>Fórmula</th>
            <td mat-cell *matCellDef="let column" >
                <div class="cell-content">
                    <mat-form-field class="no-padding-form-field-5px grid-input">            
                        <input matInput [(ngModel)]="column.formula" (ngModelChange)="changeValueFormula()">
                        <button    tabindex="-1"   type="button"  matSuffix mat-icon-button  (click)="openEditFormula(column)">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </td>
        </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"></tr>
        </mat-table>
    </expanse-panel>
</div>